import {API_ROOT_URL} from 'envs/_current/config'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'
import {schema} from "normalizr";

export const moderationItemSchema = new schema.Entity(
    'moderations',
    {},
    {
        idAttribute: 'id',
    }
)

// GET /channels/owner/:ownerType/:ownerId/pending-contents
export const moderation_getOrganizationPendingItems_Api = {
    backend: `Route::get('channels/owner/{ownerType}/{ownerId}/pending-contents', 'OrgPendingController@index');`,
    root: API_ROOT_URL,
    path: '/channels/owner/:ownerType/:ownerId/pending-contents',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'type'],
    schema: moderationItemSchema,
    transform: createListTransform(moderationItemSchema),
}

// POST /moderations/:type/:id/approve
export const moderation_approveItem_Api = {
    backend: `Route::post('moderations/{type}/{id}/approve', 'ModerationController@approve');`,
    root: API_ROOT_URL,
    path: '/moderations/:type/:id/approve',
    method: 'POST',
    schema: moderationItemSchema,
    transform: createTransform(moderationItemSchema, 'data'),
}

// POST /moderations/:type/:id/reject
export const moderation_rejectItem_Api = {
    backend: `Route::post('moderations/{type}/{id}/reject', 'ModerationController@reject');`,
    root: API_ROOT_URL,
    path: '/moderations/:type/:id/reject',
    method: 'POST',
    schema: moderationItemSchema,
    transform: createTransform(moderationItemSchema, 'data'),
}
